import React, {Component} from 'react';

import './error.page.scss';

/**
 * Error Page Component
 */
class ErrorPage extends Component {

    /**
     * Get Icon and Message details based off of error code
     * @param code
     */
    getErrorProps = (code) => {
        switch (code) {
            case 404:
                return {
                    icon: 'q4i-nodata-2pt',
                    message: 'There is no data for this page.'
                };
            default:
                return {
                    icon: 'q4i-nodata-2pt',
                    message: 'Oops, something went wrong.'
                };
        }
    };

    /**
     * Render Error Page
     * @returns {*}
     */
    render() {
        const {code} = this.props;
        const {icon, message} = this.getErrorProps(code);

        return (
            <div className={`error-page error-page--${code || ''}`}>
                <i className={`error-page_badge ${icon}`}/>
                <div className='error-page_message'>{message}</div>
            </div>
        );
    }
}

export default ErrorPage;